import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-12 text-center">
      <p className="text-6xl font-semibold text-muted-foreground">404</p>
      <h1 className="text-2xl font-semibold">{t("common.notFound.title")}</h1>
      <p className="max-w-md text-muted-foreground">
        {t("common.notFound.description")}
      </p>
      <Button asChild variant="new_default">
        <Link to="/">{t("common.notFound.goHome")}</Link>
      </Button>
    </div>
  );
};
